// extracted by mini-css-extract-plugin
export default {"contents":"hF-z","sectionHeading":"iF-z"};